export const appusers = {
  appusersSearch: 'Rechercher'
}
